import React from 'react';
import { gql } from '@apollo/client';
import { InviteController, InviteControllerProps } from './Invite.controller';
import {
  useGetInvitationDetailsLazyQuery,
  useJoinOrganizationFromInvitationMutation,
  useRegisterEmailAvailableLazyQuery
} from '../../../models/graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';
import { useUserData } from '../../../hooks/useUserData';

export type InviteApolloProps = Omit<
  InviteControllerProps,
  | 'error'
  | 'getInvitationDetails'
  | 'invitationDetails'
  | 'inviteCalled'
  | 'joinOrganizationFromInvitation'
  | 'lazyRegisterEmailAvailable'
  | 'registerEmailCalled'
  | 'userData'
  | 'submitted'
> & {
  //
};

gql`
  query GetInvitationDetails($invitationToken: String!) {
    getInvitationDetails(invitationToken: $invitationToken) {
      email
      organizationName
      organizationID
    }
  }
`;

gql`
  mutation JoinOrganizationFromInvitation($invitationToken: String!) {
    joinOrganizationFromInvitation(invitationToken: $invitationToken) {
      workspaces {
        id
      }
    }
  }
`;

export const InviteApollo = (props: InviteApolloProps): JSX.Element => {
  const [getInvitationDetails, { called: inviteCalled }] = useGetInvitationDetailsLazyQuery({
    fetchPolicy: 'no-cache'
  });

  const [joinOrganizationFromInvitation, { loading: joinLoading, error: joinError }] =
    useJoinOrganizationFromInvitationMutation({ fetchPolicy: 'no-cache' });

  const [lazyRegisterEmailAvailable, { called: registerEmailCalled }] = useRegisterEmailAvailableLazyQuery({
    fetchPolicy: 'no-cache'
  });

  const { userData, loading: loadingUserData, error: userDataError } = useUserData();

  let submitted = false;
  let error: string | JSX.Element = '';

  if (joinLoading || loadingUserData) {
    submitted = true;
    error = '';
  }
  if (joinError || userDataError) {
    const currentError = joinError || userDataError;
    submitted = false;
    error = remapApolloErrors(currentError);
  }

  const controllerProps: InviteControllerProps = {
    ...props,
    error,
    getInvitationDetails,
    inviteCalled,
    joinOrganizationFromInvitation,
    lazyRegisterEmailAvailable,
    registerEmailCalled,
    submitted,
    userData
  };

  return <InviteController {...controllerProps} />;
};
